import { render } from "./CommonTableComponent.vue?vue&type=template&id=2cd2aa2f&scoped=true"
import script from "./CommonTableComponent.vue?vue&type=script&lang=js"
export * from "./CommonTableComponent.vue?vue&type=script&lang=js"

import "./CommonTableComponent.vue?vue&type=style&index=0&id=2cd2aa2f&scoped=true&lang=css"
import "./CommonTableComponent.vue?vue&type=style&index=1&id=2cd2aa2f&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cd2aa2f"]])

export default __exports__